import { Component, HostListener, inject } from '@angular/core';
import { ConfirmDialogService } from '../../services/confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.css',
})
export class ConfirmDialogComponent {
  protected confirmDialogService: ConfirmDialogService = inject(ConfirmDialogService);

  accept(): void {
    this.confirmDialogService.resolve(true);
  }

  cancel(): void {
    this.confirmDialogService.resolve(false);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.confirmDialogService.dialog()) {
      this.cancel();
    }
  }
}
